import { Component, Input, OnInit } from '@angular/core';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { TFileChangeInfo, TPushNotification } from '../../notification.model';
import { getNotificationReasonText } from '../../utils/notification-reason';

@Component({
    selector: 'pp-notification-images360',
    templateUrl: './notification-images360.component.html',
    styleUrls: ['../notification.component.scss'],
    standalone: false
})
export class NotificationImages360Component implements OnInit {
  @Input() ppNotification: TPushNotification<TFileChangeInfo[]>;

  notificationReason: string;
  EIconPath = EIconPath;

  constructor() {}

  ngOnInit(): void {
    this.notificationReason = getNotificationReasonText(this.ppNotification.notificationReason);
  }
}
